import { serverInfo } from "../../redux/slices"
import { Table } from "reactstrap"
import { useSelector, useDispatch } from "react-redux"
import { DefaultState } from "../../types"
import { useEffect } from "react"
import prettyBytes from "pretty-bytes"

const ServerInfoBody = () => {
    const server = useSelector((state: DefaultState) => state.server)
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(serverInfo())
    }, [])

    return (
        <>
        <Table>
            <thead>
                <tr>
                    <th>OS Version Info</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>Version</td> 
                    <td>{server.version}</td>
                </tr>
            </tbody>
            <thead>
                <tr>
                    <th>CPU Info</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>Processors</td> 
                    <td>{server.cpuinfo.processors}</td>
                </tr>
                <tr>
                    <td>Model Name</td>
                    <td>{server.cpuinfo.modelName}</td>
                </tr>
                <tr>
                    <td>CPU MHz</td>
                    <td></td>
                </tr>
            </tbody>
            <thead>
                <tr>
                    <th>RAM Info</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>Mem Total</td> 
                    <td>{prettyBytes(server.meminfo.memTotal)}</td>
                </tr>
                <tr>
                    <td>Mem Free</td>
                    <td>{prettyBytes(server.meminfo.memFree)}</td>
                </tr>
                <tr>
                    <td>Mem Available</td>
                    <td>{prettyBytes(server.meminfo.memAvail)}</td>
                </tr>
            </tbody>
            <thead>
                <tr>
                    <th>Network Interface</th>
                </tr>
            </thead>
            <tbody>
                {server.network.map((net, index) => {
                    return <tr key={index}>
                     <td>{net.name}</td> 
                     <td>{net.mac}</td>
                    </tr>
                })}
            </tbody>
        </Table>
        </>
    )
}

export default ServerInfoBody